<template>
  <v-form>
    <v-container fluid>
      <v-layout>
        <v-flex xs12 md4>
          <v-layout class="mb-4">
            <v-flex xs12 md6>
              <v-select :label="$t('available_periods')" :items="periods" item-text="title" item-value="id" v-model="currentPeriod"></v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mb-3">
            <v-flex xs12 md10>
              <h4>Дата закрытия внесения плановых значений</h4>
              <v-layout>
                <v-flex xs12 md8>
                  <v-menu :nudge-right="40" full-width min-width="290px">
                    <template #activator="{ on }">
                      <v-text-field :label="$t('date')" v-model="planDueDateD" prepend-icon="event" readonly v-on="on" />
                    </template>
                    <v-date-picker v-model="planDueDateD" no-title scrollable :locale="$i18n.locale" />
                  </v-menu>
                </v-flex>
                <v-flex xs12 md4>
                  <v-menu ref="menuPlanDueDateT" :nudge-right="40" full-width min-width="290px" :close-on-content-click="false">
                    <template #activator="{ on }">
                      <v-text-field :label="$t('time')" v-model="planDueDateT" prepend-icon="access_time" readonly v-on="on" />
                    </template>
                    <v-time-picker v-model="planDueDateT" full-width format="24hr" @click:minute="$refs.menuPlanDueDateT.save(planDueDateT)" />
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 md10>
              <h4>Дата закрытия внесения итоговых значений</h4>
              <v-layout>
                <v-flex xs12 md8>
                  <v-menu :nudge-right="40" full-width min-width="290px">
                    <template #activator="{ on }">
                      <v-text-field :label="$t('date')" v-model="valueDueDateD" prepend-icon="event" readonly v-on="on" />
                    </template>
                    <v-date-picker v-model="valueDueDateD" no-title scrollable :locale="$i18n.locale" />
                  </v-menu>
                </v-flex>
                <v-flex xs12 md4>
                  <v-menu ref="menuValueDueDateT" :nudge-right="40" full-width min-width="290px" :close-on-content-click="false">
                    <template #activator="{ on }">
                      <v-text-field :label="$t('time')" v-model="valueDueDateT" prepend-icon="access_time" readonly v-on="on" />
                    </template>
                    <v-time-picker v-model="valueDueDateT" full-width format="24hr" @click:minute="$refs.menuValueDueDateT.save(valueDueDateT)" />
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex class="text-xs-right">
              <v-btn color="primary" @click="saveSettings" :disabled="!valid">Сохранить</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'ConfigView',
  data: () => ({
    loading: true,
    currentPeriod: null,
    planDueDateD: null,
    planDueDateT: null,
    valueDueDateD: null,
    valueDueDateT: null
  }),
  computed: {
    periods () {
      return Object.values(this.$store.getters["periods/periods"])
    },
    settings () {
      return this.$store.getters.settings
    },
    valid () {
      return this.currentPeriod && this.planDueDateD && this.planDueDateT && this.valueDueDateD && this.valueDueDateT
    }
  },
  async mounted () {
    this.loading = true
    await this.loadPeriods()
    await this.loadSettings()
    this.loading = false
  },
  methods: {
    async loadPeriods () {
      await this.$store.dispatch("periods/getPeriods")
    },
    async loadSettings () {
      const options = [
        'plan-due-date',
        'value-due-date',
        'current-period'
      ]
      await this.$store.dispatch('loadSettings', { options })

      this.currentPeriod = this.settings['current-period'] || null
      if (this.settings['plan-due-date']) {
        const dt = new Date(this.settings['plan-due-date'])
        this.planDueDateD = `${dt.getFullYear()}-${('00'+(dt.getMonth()+1)).slice(-2)}-${('00'+dt.getDate()).slice(-2)}`
        this.planDueDateT = `${('0'+dt.getHours()).slice(-2)}:${('0'+dt.getMinutes()).slice(-2)}`
      }
      if (this.settings['value-due-date']) {
        const dt = new Date(this.settings['value-due-date'])
        this.valueDueDateD = `${dt.getFullYear()}-${('00'+(dt.getMonth()+1)).slice(-2)}-${('00'+dt.getDate()).slice(-2)}`
        this.valueDueDateT = `${('0'+dt.getHours()).slice(-2)}:${('0'+dt.getMinutes()).slice(-2)}`
      }
    },
    async saveSettings () {
      if (!this.valid) {
        this.$events.$emit('notify', {
          message: 'Указаны не верные параметры',
          type: 'error'
        })
        return
      }

      const options = {
        'current-period': this.currentPeriod,
        'plan-due-date': `${this.planDueDateD} ${this.planDueDateT}`,
        'value-due-date': `${this.valueDueDateD} ${this.valueDueDateT}`
      }
      await this.$store.dispatch('saveSettings', { options })
    }
  }
}
</script>

<i18n>
{
  "ru": {
    "available_periods": "Текущий период",
    "date": "Дата",
    "time": "Время"
  },
  "kz": {}
}
</i18n>
